const isDev = process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'local'
const isLocal = process.env.REACT_APP_ENV === 'local'
const serialize = object => JSON.stringify(object, null, 2)

module.exports = {
  isDev,
  isLocal,
  serialize,
}
